import { render } from "./ProgramLandingPage.vue?vue&type=template&id=5dc6a9b9"
import script from "./ProgramLandingPage.vue?vue&type=script&lang=js"
export * from "./ProgramLandingPage.vue?vue&type=script&lang=js"

import "./ProgramLandingPage.vue?vue&type=style&index=0&id=5dc6a9b9&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__